/**
 * @author caijianjia
 * @date 2020/4/3 7:54 下午
 */
export const fields = {
    move:[
        {
            "name": "请选择",
            "value": [],
            "type": "Cascader",
            "props": {
                "placeholder": "请选择",
                "rules": {
                    "required": true,
                    "message": "请选择"
                }
            },
            "options": [
                {
                    "key": "1",
                    "value": "模块1"
                },
                {
                    "key": "2",
                    "value": "模块2"
                }
            ]
        }
    ],
    copy:[
        {
            "name": "请选择",
            "value": [],
            "type": "Cascader",
            "props": {
                "placeholder": "请选择",
                "rules": {
                    "required": true,
                    "message": "请选择"
                }
            },
            "options": [
                {
                    "key": "1",
                    "value": "模块1"
                },
                {
                    "key": "2",
                    "value": "模块2"
                }
            ]
        }
    ],
    addNavItem:[
        {
            "name": "请输入",
            "value": "",
            "type": "Input",
            "props": {
                "placeholder": "请输入",
                "rules": {
                    "required": true,
                    "message": "请输入",
                    "target": "blur"
                }
            }
        }
    ],
    editNavLeaf:[
        {
            "name": "请输入",
            "value": "",
            "type": "Input",
            "props": {
                "placeholder": "请输入",
                "rules": {
                    "required": true,
                    "message": "请输入",
                    "target": "blur"
                }
            }
        }
    ],
    editNavItem:[
        {
            "name": "请输入",
            "value": "",
            "type": "Input",
            "props": {
                "placeholder": "请输入",
                "rules": {
                    "required": true,
                    "message": "请输入",
                    "target": "blur"
                }
            }
        }
    ],
    replaceNav:[
        {
            attr: 'selectStage',
            "name": "请选择",
            "value": "",
            "type": "SelectGroup",
            "props": {
                "placeholder": "请选择",
                "rules": {
                    "required": true,
                    "message": "请选择",
                    "target": "blur"
                }
            },
            options: []
        }
    ],
    setTemplate:[
        {
            "name": "新模版名称",
            "value": "",
            "type": "Input",
            "props": {
                "placeholder": "请输入",
                "rules": {
                    "required": true,
                    "message": "请输入",
                    "target": "blur"
                }
            }
        }
    ]
}
